export default {
    resetLetterOfContentOrder(state) {
        const order = {
            type: 'LETTEROFCONTENT',
            relation: {
                id: null,
                createTimestamp: null,
                modifiedTimestamp: null,
                deletedTimestamp: null,
                isAnonymized: null,
                organizationID: null,
                externalReference: null,
                type: 'CONSUMER',
                isParent: null,
                parentID: null,
                firstName: null,
                middleName: null,
                lastName: null,
                gender: 'MALE',
                birthDate: null,
                phoneNumber: null,
                mobileNumber: null,
                email: null,
                street: null,
                houseNumber: null,
                houseNumberAddition: null,
                postalCode: null,
                city: null,
                country: null,
                companyName: null,
                companyCocNumber: null,
                bankAccountType: null,
                bankAccountNumber: null,
                debtorName: null,
                saveToRevision: false,
            },
            relationID: null,
            signatureType: 'ESIGNATURE',
            signatureData: null,
            productID: 2001,
            key: Math.random(),
            flowQuestions: [],
            extraData: {
                notes: '',
            },
        };
        state.order = order;
    },

    preFillRelationOnLetterOfContentOrderBegin(state) {
        state.errorPreFillRelationOnOrder = false;
        state.loadingPreFillRelationOnOrder = true;
    },

    preFillRelationOnLetterOfContentOrderSuccess(state) {
        state.loadingPreFillRelationOnOrder = false;
    },

    preFillRelationOnLetterOfContentOrderErr(state, err) {
        state.loadingPreFillRelationOnOrder = false;
        state.errorPreFillRelationOnOrder = err;
    },

    addRelationToLetterOfContentOrder(state, data) {
        const order = JSON.parse(JSON.stringify(state.order));

        if (data.type === 'CONSUMER') {
            data.companyName = null;
            data.companyCocNumber = null;
        }

        order.relation = data;
        if (data.id !== undefined) {
            order.relationID = data.id;
        }
        order.key = Math.random();
        state.order = order;
    },

    createLetterOfContentOrderBegin(state) {
        state.errorCreateOrder = false;
        state.loadingCreateOrder = true;
    },

    createLetterOfContentOrderSuccess(state) {
        state.loadingCreateOrder = false;
    },

    createLetterOfContentOrderErr(state, err) {
        state.loadingCreateOrder = false;
        state.errorCreateOrder = err;
    },

    setSignatureLetterOfContentData(state, data) {
        const order = JSON.parse(JSON.stringify(state.order));
        order.signatureData = data;
        order.key = Math.random();
        state.order = order;
    },

    fetchLetterOfContentFlowQuestionsBegin(state) {
        state.loadingFetchLetterOfContentFlowQuestions = true;
    },
    fetchLetterOfContentFlowQuestionsSuccess(state, flowQuestions) {
        const order = JSON.parse(JSON.stringify(state.order));
        order.flowQuestions = flowQuestions.data;
        order.key = Math.random();
        state.order = order;
        state.loadingFetchLetterOfContentFlowQuestions = false;
    },
    fetchLetterOfContentFlowQuestionsErr(state, err) {
        state.loadingFetchLetterOfContentFlowQuestions = false;
        state.errorFetchLetterOfContentFlowQuestions = err;
    }
};
